import { render, staticRenderFns } from "./HeroTextMediaColumnsItem.vue?vue&type=template&id=e5638820"
import script from "./HeroTextMediaColumnsItem.vue?vue&type=script&lang=ts"
export * from "./HeroTextMediaColumnsItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports